import { render, staticRenderFns } from "./GraphDetail13.vue?vue&type=template&id=7504c074&scoped=true"
import script from "./GraphDetail13.vue?vue&type=script&lang=js"
export * from "./GraphDetail13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504c074",
  null
  
)

export default component.exports